import { type CoralBreakpoint } from "@octopus-energy/coral-design"
import { getMediaQuery } from "../utils/mediaQueries"

export function useMediaQuery({
    breakpoint,
    type,
    queryType,
}: {
    breakpoint: CoralBreakpoint
    type?: "min-width" | "max-width"
    queryType?: string | null
}) {
    return getMediaQuery(breakpoint, type, queryType)()
}
